export enum Authority {
	//Authority
	ADMIN = 'ROLE_ADMIN',
	USER = 'ROLE_USER',
	ANONYMOUS = 'ROLE_ANONYMOUS',

	//Entity: WHATSAPP
	WHATSAPP_CREATE = 'WHATSAPP_CREATE',
	WHATSAPP_READ = 'WHATSAPP_READ',
	WHATSAPP_VIEW = 'WHATSAPP_VIEW',
	WHATSAPP_UPDATE = 'WHATSAPP_UPDATE',
	WHATSAPP_DELETE = 'WHATSAPP_DELETE',
	WHATSAPP_CONFIGURATION = 'WHATSAPP_CONFIGURATION',

	//Entity: AUDIT_EVENT
	AUDIT_EVENT_CREATE = 'AUDIT_EVENT_CREATE',
	AUDIT_EVENT_READ = 'AUDIT_EVENT_READ',
	AUDIT_EVENT_VIEW = 'AUDIT_EVENT_VIEW',
	AUDIT_EVENT_UPDATE = 'AUDIT_EVENT_UPDATE',
	AUDIT_EVENT_DELETE = 'AUDIT_EVENT_DELETE',

	//Entity: STATUS
	STATUS_CREATE = 'STATUS_CREATE',
	STATUS_READ = 'STATUS_READ',
	STATUS_VIEW = 'STATUS_VIEW',
	STATUS_UPDATE = 'STATUS_UPDATE',
	STATUS_DELETE = 'STATUS_DELETE',

	//Entity: USER
	USER_CREATE = 'USER_CREATE',
	USER_READ = 'USER_READ',
	USER_VIEW = 'USER_VIEW',
	USER_UPDATE = 'USER_UPDATE',
	USER_DELETE = 'USER_DELETE',

	//Entity: USER_TYPE
	USER_TYPE_CREATE = 'USER_TYPE_CREATE',
	USER_TYPE_READ = 'USER_TYPE_READ',
	USER_TYPE_VIEW = 'USER_TYPE_VIEW',
	USER_TYPE_UPDATE = 'USER_TYPE_UPDATE',
	USER_TYPE_DELETE = 'USER_TYPE_DELETE',

	//Entity: NAVIGATION
	NAVIGATION_CREATE = 'NAVIGATION_CREATE',
	NAVIGATION_READ = 'NAVIGATION_READ',
	NAVIGATION_VIEW = 'NAVIGATION_VIEW',
	NAVIGATION_UPDATE = 'NAVIGATION_UPDATE',
	NAVIGATION_DELETE = 'NAVIGATION_DELETE',

	//Entity: PRODUCT
	PRODUCT_CREATE = 'RODUCT_CREATE',
	PRODUCT_READ = 'PRODUCT_READ',
	PRODUCT_VIEW = 'PRODUCT_VIEW',
	PRODUCT_UPDATE = 'PRODUCT_UPDATE',
	PRODUCT_DELETE = 'PRODUCT_DELETE',

	//Entity: PRODUCT_COMPOSITION
	PRODUCT_COMPOSITION_CREATE = 'PRODUCT_COMPOSITION_CREATE',
	PRODUCT_COMPOSITION_READ = 'PRODUCT_COMPOSITION_READ',
	PRODUCT_COMPOSITION_VIEW = 'PRODUCT_COMPOSITION_VIEW',
	PRODUCT_COMPOSITION_UPDATE = 'PRODUCT_COMPOSITION_UPDATE',
	PRODUCT_COMPOSITION_DELETE = 'PRODUCT_COMPOSITION_DELETE',

	//Entity: PRODUCT_GROUP
	PRODUCT_GROUP_CREATE = 'PRODUCT_GROUP_CREATE',
	PRODUCT_GROUP_READ = 'PRODUCT_GROUP_READ',
	PRODUCT_GROUP_VIEW = 'PRODUCT_GROUP_VIEW',
	PRODUCT_GROUP_UPDATE = 'PRODUCT_GROUP_UPDATE',
	PRODUCT_GROUP_DELETE = 'PRODUCT_GROUP_DELETE',

	//Entity: PRODUCT_GROUP_METADATA
	PRODUCT_GROUP_METADATA_CREATE = 'PRODUCT_GROUP_METADATA_CREATE',
	PRODUCT_GROUP_METADATA_READ = 'RODUCT_GROUP_METADATA_READ',
	PRODUCT_GROUP_METADATA_VIEW = 'PRODUCT_GROUP_METADATA_VIEW',
	PRODUCT_GROUP_METADATA_UPDATE = 'PRODUCT_GROUP_METADATA_UPDATE',
	PRODUCT_GROUP_METADATA_DELETE = 'PRODUCT_GROUP_METADATA_DELETE',

	//Entity: PRODUCT_GROUP_REFERENCE
	PRODUCT_GROUP_REFERENCE_CREATE = 'PRODUCT_GROUP_REFERENCE_CREATE',
	PRODUCT_GROUP_REFERENCE_READ = 'PRODUCT_GROUP_REFERENCE_READ',
	PRODUCT_GROUP_REFERENCE_VIEW = 'PRODUCT_GROUP_REFERENCE_VIEW',
	PRODUCT_GROUP_REFERENCE_UPDATE = 'PRODUCT_GROUP_REFERENCE_UPDATE',
	PRODUCT_GROUP_REFERENCE_DELETE = 'PRODUCT_GROUP_REFERENCE_DELETE',

	//Entity: PRODUCT_GROUP_REFERENCE_METADATA
	PRODUCT_GROUP_REFERENCE_METADATA_CREATE = 'PRODUCT_GROUP_REFERENCE_METADATA_CREATE',
	PRODUCT_GROUP_REFERENCE_METADATA_READ = 'PRODUCT_GROUP_REFERENCE_METADATA_READ',
	PRODUCT_GROUP_REFERENCE_METADATA_VIEW = 'PRODUCT_GROUP_REFERENCE_METADATA_VIEW',
	PRODUCT_GROUP_REFERENCE_METADATA_UPDATE = 'PRODUCT_GROUP_REFERENCE_METADATA_UPDATE',
	PRODUCT_GROUP_REFERENCE_METADATA_DELETE = 'PRODUCT_GROUP_REFERENCE_METADATA_DELETE',

	//Entity: PRODUCT_METADATA
	PRODUCT_METADATA_CREATE = 'PRODUCT_METADATA_CREATE',
	PRODUCT_METADATA_READ = 'PRODUCT_METADATA_READ',
	PRODUCT_METADATA_VIEW = 'PRODUCT_METADATA_VIEW',
	PRODUCT_METADATA_UPDATE = 'PRODUCT_METADATA_UPDATE',
	PRODUCT_METADATA_DELETE = 'PRODUCT_METADATA_DELETE',

	//Entity: PRODUCT_REFERENCE
	PRODUCT_REFERENCE_CREATE = 'PRODUCT_REFERENCE_CREATE',
	PRODUCT_REFERENCE_READ = 'PRODUCT_REFERENCE_READ',
	PRODUCT_REFERENCE_VIEW = 'PRODUCT_REFERENCE_VIEW',
	PRODUCT_REFERENCE_UPDATE = 'PRODUCT_REFERENCE_UPDATE',
	PRODUCT_REFERENCE_DELETE = 'PRODUCT_REFERENCE_DELETE',

	//Entity: PRODUCT_TYPE
	PRODUCT_TYPE_CREATE = 'PRODUCT_TYPE_CREATE',
	PRODUCT_TYPE_READ = 'PRODUCT_TYPE_READ',
	PRODUCT_TYPE_VIEW = 'PRODUCT_TYPE_VIEW',
	PRODUCT_TYPE_UPDATE = 'PRODUCT_TYPE_UPDATE',
	PRODUCT_TYPE_DELETE = 'PRODUCT_TYPE_DELETE',

	//Entity: PRODUCT_TYPE_MATERIAL
	PRODUCT_TYPE_MATERIAL_CREATE = 'PRODUCT_TYPE_MATERIAL_CREATE',
	PRODUCT_TYPE_MATERIAL_READ = 'PRODUCT_TYPE_MATERIAL_READ',
	PRODUCT_TYPE_MATERIAL_VIEW = 'PRODUCT_TYPE_MATERIAL_VIEW',
	PRODUCT_TYPE_MATERIAL_UPDATE = 'PRODUCT_TYPE_MATERIAL_UPDATE',
	PRODUCT_TYPE_MATERIAL_DELETE = 'PRODUCT_TYPE_MATERIAL_DELETE',

	//Entity: PRODUCT_TYPE_MATERIAL_METADATA
	PRODUCT_TYPE_MATERIAL_METADATA_CREATE = 'PRODUCT_TYPE_MATERIAL_METADATA_CREATE',
	PRODUCT_TYPE_MATERIAL_METADATA_READ = 'RODUCT_TYPE_MATERIAL_METADATA_READ',
	PRODUCT_TYPE_MATERIAL_METADATA_VIEW = 'PRODUCT_TYPE_MATERIAL_METADATA_VIEW',
	PRODUCT_TYPE_MATERIAL_METADATA_UPDATE = 'PRODUCT_TYPE_MATERIAL_METADATA_UPDATE',
	PRODUCT_TYPE_MATERIAL_METADATA_DELETE = 'PRODUCT_TYPE_MATERIAL_METADATA_DELETE',

	//Entity: METADATA_KEY
	METADATA_KEY_CREATE = 'METADATA_KEY_CREATE',
	METADATA_KEY_READ = 'METADATA_KEY_READ',
	METADATA_KEY_VIEW = 'METADATA_KEY_VIEW',
	METADATA_KEY_UPDATE = 'METADATA_KEY_UPDATE',
	METADATA_KEY_DELETE = 'METADATA_KEY_DELETE',

	//Entity: BLOG
	BLOG_CREATE = 'BLOG_CREATE',
	BLOG_READ = 'BLOG_READ',
	BLOG_VIEW = 'BLOG_VIEW',
	BLOG_UPDATE = 'BLOG_UPDATE',
	BLOG_DELETE = 'BLOG_DELETE',
}
